import React from "react"
import { graphql } from "gatsby"
import { Typography } from "antd"
import Layout from "../../../components/Layout"
import "../../../styles/odooServices.scss"
import "../../../styles/services.scss"
import "../../../styles/caseStudy.scss"

import News from "../../../components/News"
import ProductTopSection from "../../../components/ProductTopSelection"
import ServiceCard from "../../../components/ServiceCard"
import Wethoughtyoumighthavequestions from "../../../components/Wethoughtyoumighthavequestions"

import ImageWithTextSection from "../../../components/ImageWithTextSection"
import sc_deployment from "../../../images/servicecard/deployment.png"
import sc_integration from "../../../images/servicecard/integration.png"
import sc_uiux from "../../../images/servicecard/UIUX design.png"
import sc_performance from "../../../images/servicecard/performance.png"
import sc_ecommerce from "../../../images/servicecard/E-commerce.png"
import sc_cloud from "../../../images/servicecard/cloud.png"

const { Title } = Typography

const ClassManagement = ({ data }) => {
    return (
        <div className="CaseStudeies">
            <Layout pageTitle={"Visiomate - Class Management Solution"}
            descrip = {"Streamline your classroom with our powerful class management solution. Simplify attendance, assignments, grading, and communication. Try it today!"}>
                <ProductTopSection
                    headerData={{
                        title:
                            "Revolutionize Your Processes with Our Comprehensive Class Management Solution",
                        peragraph:
                            "Centralizing tasks and fostering collaboration, our Class Management Solution optimizes education operations for efficient learning outcomes and enriched student experiences.",
                        // image: headerImage,
                    }}
                    data={data}
                />
                <div className="services-page-container position-relative">
                  <div className="services-description-section">
                    <div className="service-heading-and-detail">
                      <Title>Smarter Tools for a Better Learning Experience</Title>
                    </div>
                    <div className="service-cards-wrapper">
                      <ServiceCard
                        img_src={sc_deployment}
                        img_alt="Streamlined Administrative Tasks"
                        card_heading="Streamlined Administrative Tasks"
                        card_para="Automates processes such as scheduling, attendance tracking, grading, and resource allocation, reducing administrative burden and improving efficiency."
                      />
                      <ServiceCard
                        img_src={sc_integration}
                        img_alt="Improved Communication"
                        card_heading="Improved Communication"
                        card_para="Provides centralized communication channels for teachers, students, and parents, facilitating quick and effective communication, feedback, and updates."
                      />
                      <ServiceCard
                        img_src={sc_uiux}
                        img_alt="Enhanced Collaboration"
                        card_heading="Enhanced Collaboration"
                        card_para="Offers tools for collaborative learning and group projects, fostering teamwork, knowledge sharing, and peer interaction."
                      />
                      <ServiceCard
                        img_src={sc_performance}
                        img_alt="Efficient Learning Outcomes"
                        card_heading="Efficient Learning Outcomes"
                        card_para="Supports personalized learning pathways, progress tracking, and analytics to identify areas for improvement, leading to more effective teaching and learning."
                      />
                      <ServiceCard
                        img_src={sc_ecommerce}
                        img_alt="Enriched Student Experiences"
                        card_heading="Enriched Student Experiences"
                        card_para="Enhances engagement through interactive learning materials, multimedia resources, and gamification elements, creating a more dynamic and immersive learning environment."
                      />
                      <ServiceCard
                        img_src={sc_cloud}
                        img_alt="Data-Driven Decision Making"
                        card_heading="Data-Driven Decision Making"
                        card_para="Enabling educators and administrators to make informed decisions based on accurate data, leading to continuous improvement in teaching strategies and student performance."
                      />
                    </div>
                  </div>
                </div>
                <ImageWithTextSection
                    title="Inside the Class Management Platform"
                    caseStudyData={{
                        data: [
                            {
                                heading: "Dashboards",
                                description:
                                    " Graphs, charts, and other visual elements make complex data more comprehensible, enabling users to quickly grasp trends, patterns, and outliers.",
                                // image: img1,
                            },
                            {
                                heading: "Dynamic Admission Form Builder",
                                description:
                                    "Our CMS features a dynamic admission form builder akin to Google Forms, enabling creation of sections, pages, diverse question types, and conditional logic for both required and optional responses.",
                                // image: img2,
                            },
                            {
                                heading: "Manual or Auto Generated Timetable",
                                description:
                                    "The timetable feature allow users to craeted timetable on a single click. The Auto generated timetable uses the availability and preference set for the teachers and rooms to build the suitable timtable.",
                                // image: img3,
                            },
                            {
                                heading: "Multiple Views of Timetable",
                                description:
                                    "The timetable be viewed from the perspective of a single teacher, subject and room. Additionally, the timetable can be viewed for all teacher, all subjects and all rooms as well.",
                                // image: img4,
                            },
                            {
                                heading: "Manage Session, Programs, Classes and Sub-Classes",
                                description:
                                    "The education management system allows users to create multiple sessions, programs and classes in the hierarchy.",
                                // image: img5,
                            },
                            {
                                heading: "8 Steps Detailed Class Creation",
                                description:
                                    "The education management system provides a wide range of attributes for a class. The class attributes are grouped into basic information, registartion and seats, schedule, billing and payment, terms and condition and application form.",
                                // image: img6,
                            },
                            {
                                heading: "Separate Portal for Teachers, Students and Parents",
                                description:
                                    "The education management system offers separate portal for teachers, students and parents. Teachers and students can use there portal to moniter and participate in class activity, communicate with other students or with teacher.",
                                // image: img7,
                            },
                            {
                                heading: "Manage Teachers, Students, Subjects and Enrollments",
                                description:
                                    "The education management system provides ability to manage data related to teachers, students, subjects and enrollments.",
                                // image: img8,
                            },
                            {
                                heading: "Manage Multiple Locations",
                                description:
                                    "The education management system provides ability create multiple location inside a single school which helps user get specific reports.",
                                // image: img9,
                            },
                            {
                                heading: "Up-front Complete Planned Payments Information",
                                description:
                                    "The education management system provides ability to view all the planned invoices for the enrolled class.",
                                // image: img10,
                            },
                        ],
                    }}
                    dataFormImages={data}
                />
                <Wethoughtyoumighthavequestions
                    data={[
                        {
                            question: "What is the Class Management Application?",
                            answer: "Our Class Management Application is an end-to-end platform for educational institutions and training centers to manage sessions, programs, classes, enrollments, timetables, attendance, and payments — all in one unified system.",
                        },
                        {
                            question: "How does the dynamic timetable feature work?",
                            answer: "The system can generate a timetable automatically in a single click based on teacher availability, room capacity, and subject preferences — or administrators can build one manually. Timetables can be viewed by teacher, subject, or room across all classes simultaneously.",
                        },
                        {
                            question: "How are students registered for classes?",
                            answer: "Admins can build custom registration forms — similar to Google Forms — with multiple sections, question types, and conditional logic. Students fill out the form online to enroll, and their data flows directly into the system.",
                        },
                        {
                            question: "Are there separate portals for teachers, students, and parents?",
                            answer: "Yes. Each user type has a dedicated portal. Teachers can post materials, track attendance, and communicate with students. Students can view their schedule and class activity. Parents can monitor progress and stay informed in real time.",
                        },
                        {
                            question: "How does attendance tracking work?",
                            answer: "Instructors record attendance directly through their portal. The system tracks punctuality, absences, and generates attendance reports that administrators can use to monitor compliance and identify students who may need additional support.",
                        },
                        {
                            question: "Can the platform handle billing and payments for classes?",
                            answer: "Yes. The platform supports structured billing plans linked to class enrollments. Students and parents can view all planned invoices upfront, and the system tracks payment status — reducing the administrative burden on finance teams.",
                        },
                    ]}
                    title="We thought you might have questions"
                />
                <News isAbout={true} career={true} />
            </Layout>
        </div>
    )
}

export default ClassManagement
export const query = graphql`
  query ClassManagementImages {
    VMLogoBlack: file(relativePath: { eq: "logo_black_LST.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    VMLogoWhite: file(relativePath: { eq: "logo_white_LST.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    HeaderImg: file(relativePath: { eq: "EMS/ems_top_header.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    markFlag: file(
      relativePath: { eq: "4879902_check_flag_mark_ok_icon_1_copy.png" }
    ) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    bgImages: file(relativePath: { eq: "prodbg-01.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    img1: file(relativePath: { eq: "EMS/1.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    img2: file(relativePath: { eq: "EMS/2.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    img3: file(relativePath: { eq: "EMS/3.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    img4: file(relativePath: { eq: "EMS/4.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    img5: file(relativePath: { eq: "EMS/5.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    img6: file(relativePath: { eq: "EMS/6.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    img7: file(relativePath: { eq: "EMS/7.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    img8: file(relativePath: { eq: "EMS/8.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    img9: file(relativePath: { eq: "EMS/9.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    img10: file(relativePath: { eq: "EMS/10.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`
